export default __webpack_public_path__ + "static/media/Gesture icons_Stroke.17a5672b.svg";